import { useServices } from '@/components/ServiceContext';
import React from 'react';
import GenericReportPage from '@/pages/Reports/GenericReportPage';
import { reportDefinitions } from '@lambda-layer/constants/reportDefinitions';

const DepositorPurgeReport: React.FC = () => {
  const { houseListService } = useServices();

  const report = reportDefinitions.find(
    rd => rd.id === 'report-hl-depositor-purge'
  );

  return (
    report && (
      <GenericReportPage
        listType="houselist"
        listService={houseListService}
        filterDefinitions={report.filterDefinitions}
        exportReportName={report.exportName}
      />
    )
  );
};

export default DepositorPurgeReport;
